var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.77767,
    y: 4.86263,
    width: 31.6667,
    height: 31.6667,
    rx: 15.8333,
    stroke: "white",
    strokeWidth: 1.66667
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_8427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 17.3395C15.3988 17.2734 15.4767 17.2209 15.5625 17.1851C15.6483 17.1493 15.7404 17.1309 15.8334 17.1309C15.9264 17.1309 16.0185 17.1493 16.1043 17.1851C16.1901 17.2209 16.268 17.2734 16.3334 17.3395C16.4662 17.4737 16.5407 17.6549 16.5407 17.8437C16.5407 18.0325 16.4662 18.2137 16.3334 18.3479L14.7101 19.9812H28.2218C28.4109 19.9812 28.5924 20.0564 28.7262 20.1901C28.8599 20.3239 28.9351 20.5054 28.9351 20.6945C28.9351 20.8837 28.8599 21.0652 28.7262 21.1989C28.5924 21.3327 28.4109 21.4079 28.2218 21.4079H14.7101L16.3334 23.0412C16.4637 23.175 16.5367 23.3544 16.5367 23.5412C16.5367 23.728 16.4637 23.9074 16.3334 24.0412C16.268 24.1073 16.1901 24.1598 16.1043 24.1956C16.0185 24.2314 15.9264 24.2499 15.8334 24.2499C15.7404 24.2499 15.6483 24.2314 15.5625 24.1956C15.4767 24.1598 15.3988 24.1073 15.3334 24.0412L12.5017 21.1945C12.371 21.0609 12.2979 20.8815 12.2979 20.6945C12.2979 20.5076 12.371 20.3282 12.5017 20.1945L15.3334 17.3395Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_8427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(12.2783 12.3613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPrevious);
export default __webpack_public_path__ + "static/media/button-previous.660433d7ef77adb96ecc16fb59425c37.svg";
export { ForwardRef as ReactComponent };